// src/stores/tokenStore.ts

// Magazzino globale per il token temporaneo 2FA
// Include anche backup su sessionStorage per persistenza tra refresh

const tokenStore = {
  two_fa_token: null as string | null,

  setToken(token: string) {
    this.two_fa_token = token;
    
    // Backup su sessionStorage per sicurezza
    try {
      sessionStorage.setItem('2fa_token_backup', token);
    } catch (e) {
      // Ignora errori silenziosamente
    }
  },

  getToken(): string | null {
    // Prima controlla la memoria
    if (this.two_fa_token) {
      return this.two_fa_token;
    }

    // Se non c'è in memoria, prova a recuperarlo dal sessionStorage
    try {
      const backupToken = sessionStorage.getItem('2fa_token_backup') || sessionStorage.getItem('2fa_token');
      if (backupToken) {
        this.two_fa_token = backupToken; // Ripristina in memoria
        return backupToken;
      }
    } catch (e) {
      // Ignora errori silenziosamente
    }

    return null;
  },

  clearToken() {
    this.two_fa_token = null;
    
    // Pulisce anche dai backup
    try {
      sessionStorage.removeItem('2fa_token_backup');
      sessionStorage.removeItem('2fa_token');
    } catch (e) {
      // Ignora errori silenziosamente
    }
  }
};

export default tokenStore;